export const FileViewerModes = {
  VISIBLE_ONLY: 'VISIBLE_ONLY',
  SIGNABLE: 'SIGNABLE',
};
